import { Box, Typography, Grid, Container } from "@mui/material";
import PropTypes from "prop-types";
import FeatureBlock from "components/FeatureBlock";
import { DEFAULT_FEATURES, FEATURES_CONFIG } from "constant/features";

const FeaturesSection = ({ 
  features = [], 
  title, 
  subtitle, 
  description 
}) => {
  const featuresData = features.length > 0 ? features : DEFAULT_FEATURES;

  return (
    <Box sx={{ py: { xs: 6, md: 8 } }}>
      <Container maxWidth="xl">
        <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
          <Typography
            variant="h6"
            sx={{
              color: "#17c1e8",
              fontSize: { xs: "1rem", md: "20px" },
              fontWeight: 600,
              mb: 1,
              fontFamily: "Outfit",
            }}
          >
            {subtitle || FEATURES_CONFIG.subtitle}
          </Typography>

          <Typography
            variant="h2"
            sx={{
              color: "#FFFFFF",
              fontSize: { xs: "1.8rem", sm: "2.2rem", md: "36px" },
              fontWeight: "bold",
              mb: 1,
              lineHeight: 1,
              px: { xs: 2, sm: 0 },
              fontFamily: "Outfit",
            }}
          >
            {title || FEATURES_CONFIG.title}
          </Typography>

          <Typography
            variant="h6"
            sx={{
              color: "rgba(255, 255, 255, 0.8)",
              margin: "0 auto",
              lineHeight: 1.3,
              fontSize: { xs: "0.95rem", md: "1.1rem" },
              px: { xs: 2, sm: 0 },
              fontFamily: "Outfit",
            }}
          >
            {description || FEATURES_CONFIG.description}
          </Typography>
        </Box>

        <Grid container spacing={{ xs: 3, md: 4 }} alignItems="center">
          {/* Feature Blocks Column */}
          <Grid item xs={12} lg={6}>
            <Grid container spacing={{ xs: 2, md: 2 }}>
              {featuresData.map((feature) => (
                <Grid item xs={12} sm={6} lg={12} key={feature.id}>
                  <FeatureBlock 
                    title={feature.title}
                    description={feature.description}
                    features={feature.features}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>

          {/* Phone Image Column */}
          <Grid item xs={12} lg={6}>
            <Box
              sx={{
                position: "relative",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                borderRadius: "20px",
                mt: { xs: 2, lg: 0 }
              }}
            >
              {/* Phone Mockup with Feature1 Image */}
              <Box
                sx={{
                  position: "relative",
                  width: { xs: "250px", sm: "320px", md: "380px", lg: "450px" },
                  height: { xs: "500px", sm: "640px", md: "760px", lg: "auto" },
                  maxHeight: "100%",
                  borderRadius: "30px",
                  border: "8px solid #333",
                  overflow: "hidden",
                  zIndex: 3,
                }}
              >
                <Box
                  component="img"
                  src={require("assets/images/feature1.png")}
                  alt="Feature 1 App Interface"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "22px",
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

FeaturesSection.propTypes = {
  features: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      features: PropTypes.arrayOf(PropTypes.string).isRequired,
    })
  ),
  title: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
};

export default FeaturesSection;
